function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable func-names */
import React from 'react';
import { default as CheckboxWrapper } from '@mui/material/Checkbox';
import _merge from 'lodash/merge';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { color, typography } from "../../utils/index.js";
var BpIcon = function BpIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      borderRadius: '3px',
      width: '18px',
      height: '18px',
      border: '1px solid',
      borderColor: color(COLOR_VARIANTS.GREYCHATEAU),
      background: 'transparent',
      'input:hover ~ &': {
        borderColor: color(COLOR_VARIANTS.AQUA100),
        color: color(COLOR_VARIANTS.AQUA100)
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        opacity: '0.4'
      },
      'input:disabled:hover ~ &': {
        boxShadow: 'none',
        borderColor: color(COLOR_VARIANTS.GREYCHATEAU)
      },
      'input:selected:disabled ~ &': {
        boxShadow: 'none',
        borderColor: 'transparent'
      }
    }
  });
};
var BpCheckedIcon = function BpCheckedIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      backgroundColor: color(COLOR_VARIANTS.AQUA100),
      borderRadius: '3px',
      border: '1px solid',
      borderColor: color(COLOR_VARIANTS.AQUA100),
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: '18px',
        height: '18px',
        borderRadius: '3px',
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""'
      },
      'input:hover ~ &': {
        backgroundColor: color(COLOR_VARIANTS.AQUA100)
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        opacity: '0.4'
      }
    }
  });
};
var BpCheckbox = function BpCheckbox(props) {
  return /*#__PURE__*/React.createElement(CheckboxWrapper, _extends({
    disableRipple: true,
    color: "default",
    checkedIcon: /*#__PURE__*/React.createElement(BpCheckedIcon, null),
    icon: /*#__PURE__*/React.createElement(BpIcon, null),
    inputProps: {
      'aria-label': 'Checkbox demo'
    }
  }, props, {
    sx: {
      padding: 0,
      paddingRight: '9px'
    }
  }));
};
export var Checkbox = function Checkbox(_ref) {
  var isDisabled = _ref.isDisabled,
    label = _ref.label,
    icon = _ref.icon,
    subTitle = _ref.subTitle,
    isChecked = _ref.isChecked,
    helperText = _ref.helperText,
    onChange = _ref.onChange,
    indeterminate = _ref.indeterminate,
    testId = _ref.testId,
    helperTextTestId = _ref.helperTextTestId,
    name = _ref.name,
    value = _ref.value,
    id = _ref.id,
    addMargin = _ref.addMargin,
    className = _ref.className,
    _ref$isSingle = _ref.isSingle,
    isSingle = _ref$isSingle === void 0 ? false : _ref$isSingle;
  return /*#__PURE__*/React.createElement(FormControl, {
    className: "__ds__comp ".concat(className),
    sx: {
      display: 'flex',
      flexDirection: helperText ? 'row' : 'column',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: isSingle ? '0' : '16px'
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    id: id,
    value: value,
    control: /*#__PURE__*/React.createElement(BpCheckbox, {
      inputProps: {
        'aria-label': 'Checkbox'
      },
      color: COLOR_VARIANTS.AQUA100,
      disabled: isDisabled,
      checked: isChecked,
      onChange: onChange,
      indeterminate: indeterminate,
      name: name
    }),
    label: /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
        // flexDirection: 'column'
      }
    }, icon && /*#__PURE__*/React.createElement(Box, {
      sx: {
        marginRight: '8px',
        display: 'flex'
      }
    }, icon), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    })), /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      }
    }, subTitle && icon && /*#__PURE__*/React.createElement(Box, {
      sx: {
        marginRight: '8px',
        display: 'flex',
        visibility: 'hidden'
      }
    }, icon), subTitle && /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
      color: COLOR_VARIANTS.GREYCHATEAU
    }, subTitle))),
    labelPlacement: "end",
    sx: _merge({
      color: color(COLOR_VARIANTS.MINESHAFT),
      marginLeft: 0,
      display: 'flex',
      alignItems: 'flex-start',
      '& .MuiCheckbox-root': {
        marginTop: addMargin ? '2px' : 0
      },
      '& .MuiFormControlLabel-label': _merge({}, typography(TYPOGRAPHY_VARIANT.BODY2)),
      '&:hover, &:focus': {
        color: color(COLOR_VARIANTS.AQUA100)
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: color(COLOR_VARIANTS.GREYCHATEAU)
      }
    }),
    "data-testid": testId
  }), helperText && /*#__PURE__*/React.createElement(FormHelperText, {
    "data-testid": helperTextTestId,
    sx: {
      display: 'inline-flex',
      alignSelf: !subTitle ? '' : 'center',
      marginTop: 0,
      color: color(COLOR_VARIANTS.GREYCHATEAU)
    }
  }, helperText));
};